import * as stylex from "@stylexjs/stylex";
import { styles } from "./media.styles";
import { NamePlate } from "./name-plate";

export function NamePlateStage({
  name,
  uppercase,
}: {
  readonly name: string;
  readonly uppercase: boolean;
}) {
  return (
    <div {...stylex.props(styles.carousel)}>
      <div data-store-stage="plate" {...stylex.props(styles.frame)}>
        <NamePlate name={name} uppercase={uppercase} />
      </div>
    </div>
  );
}
